module.exports = __webpack_public_path__ + "img/Xgrow-10-en.88a59648.png";